import {useEffect} from "react";
import {useMarkerStore} from "../store/markerStore";
import {updateLastAccessed} from '../utils/cacheManager'
import useLegendStore from "../store/legendStore";
import useMapStore from "../store/mapStore";
/**
 * A custom hook that observes stores that are persisted in IndexedDB and updates their last accessed timestamp on access.
 */
export default function useStoreAccess() {
  useEffect(() => {
    const unsubscribeMarkerStore = useMarkerStore.subscribe(() => {
      updateLastAccessed().catch(console.error);
    });

    return () => {
      unsubscribeMarkerStore();
    };
  }, [])

  useEffect(() => {
    const unsubscribeLegendStore = useLegendStore.subscribe(() => {
      updateLastAccessed().catch(console.error);
    });

    return () => {
      unsubscribeLegendStore();
    };
  }, [])

  useEffect(() => {
    const unsubscribeMapStore = useMapStore.subscribe(() => {
      updateLastAccessed().catch(console.error);
    });

    return () => {
      unsubscribeMapStore();
    };
  }, [])
}
